module.exports = __webpack_public_path__ + "static/media/hongkong.2614c5d8.png";